module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.macRobotList.length > 0),
      expression: "macRobotList.length>0"
    }],
    staticClass: "robot-list-type"
  }, [_vm._v("Mac Robot")]), _vm._v(" "), _vm._l((_vm.macRobotList), function(item) {
    return _c('div', {
      staticClass: "agent-list"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.icon == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": require("../../../static/img/img_app_list_icon_default.png")
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-11 col-md-10 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()]), _vm._v(" "), (item.task > 0) ? _c('div', {
      staticClass: "col-lg-10 col-md-9 col-sm-9 col-xs-8"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.$route.query.appname) + " - v" + _vm._s(item.currentVersion) + " build " + _vm._s(item.currentBuild) + " (" + _vm._s(_vm._f("formatDate")(item.currentTime / 1000000)) + ")")]), _vm._v(" "), _c('p', {
      staticClass: "robot-list-task-wait"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack"
    }), _vm._v("  "), _c('span', {
      staticClass: "robot-list-task-num"
    }, [_vm._v(_vm._s(item.task - 1))]), _vm._v(" task waiting...")])]) : _vm._e()])])])
  })], 2), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deviceRobotList.length > 0),
      expression: "deviceRobotList.length>0"
    }],
    staticClass: "robot-list-type"
  }, [_vm._v("Device Robot")]), _vm._v(" "), _vm._l((_vm.deviceRobotList), function(item) {
    return _c('div', {
      staticClass: "agent-list"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.icon == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": require("../../../static/img/img_app_list_icon_default.png")
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-11 col-md-10 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('p', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-2 col-md-3 col-sm-3 col-xs-4"
    }, [(item.isOnline == false) ? _c('span', {
      staticClass: "robot-list-status label label-default"
    }, [_vm._v("offline")]) : (item.task == 0) ? _c('span', {
      staticClass: "robot-list-status label label-info"
    }, [_vm._v("free")]) : (item.task > 0) ? _c('span', {
      staticClass: "robot-list-status label label-warning"
    }, [_vm._v("building")]) : _vm._e()]), _vm._v(" "), (item.task > 0) ? _c('div', {
      staticClass: "col-lg-10 col-md-9 col-sm-9 col-xs-8"
    }, [_c('p', [_vm._v(" " + _vm._s(_vm.$route.query.appname) + " - v" + _vm._s(item.currentVersion) + " build " + _vm._s(item.currentBuild) + " (" + _vm._s(_vm._f("formatDate")(item.currentTime / 1000000)) + ")")]), _vm._v(" "), _c('p', {
      staticClass: "robot-list-task-wait"
    }, [_c('i', {
      staticClass: "fa fa-thumb-tack"
    }), _vm._v("  "), _c('span', {
      staticClass: "robot-list-task-num"
    }, [_vm._v(_vm._s(item.task - 1))]), _vm._v(" task waiting...")])]) : _vm._e()])])])
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7579bcc8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7579bcc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RobotList.vue
// module id = 484
// module chunks = 1